<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-calendar-week', fontSet: 'fad'}"
	[headerText]="data?.title"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<mat-form-field class="full-width-form" color="accent" id="startFormField">
			<mat-label>{{ T.DATE_PICKER_CHOOSE_A_STARTING_DATE | translate }}</mat-label>
			<input
				(click)="datepicker.open()"
				(focusin)="datepicker.open()"
				[formControl]="startFormControl"
				[matDatepicker]="datepicker"
				[readonly]="true"
				matInput
				name="userExpirationStart"
			/>
			<mat-datepicker-toggle [for]="datepicker" matSuffix />
			@if (startFormControl?.value) {
				<button (click)="startFormControl.reset()" [@zoomInOnEnter] aria-label="Clear" color="warn" mat-icon-button matSuffix>
					<mat-icon fontSet="fas" fontIcon="fa-times" inline />
				</button>
			}
			<mat-datepicker #datepicker />
		</mat-form-field>

		<mat-form-field class="full-width-form" color="accent" id="endFormField">
			<mat-label>{{ T.DATE_PICKER_CHOOSE_ENDING_DATE | translate }}</mat-label>
			<input
				(click)="datepickerEnd.open()"
				(focusin)="datepickerEnd.open()"
				[formControl]="endFormControl"
				[matDatepicker]="datepickerEnd"
				[min]="startFormControl?.value ? startFormControl?.value : nowDate"
				[readonly]="true"
				matInput
				name="userExpirationEnd"
			/>
			<mat-datepicker-toggle [for]="datepickerEnd" matSuffix />
			@if (endFormControl?.value) {
				<button (click)="endFormControl.reset()" [@zoomInOnEnter] aria-label="Clear" color="warn" mat-icon-button matSuffix>
					<mat-icon fontSet="fas" fontIcon="fa-times" inline />
				</button>
			}
			<mat-datepicker #datepickerEnd />
		</mat-form-field>
	</ng-container>

	<ng-container actions>
		<button (click)="close({action: 'close'})" color="warn" mat-raised-button>{{ T.BUTTON_CLOSE | translate }}</button>

		<button (click)="startFormControl.reset(); endFormControl.reset()" color="warn" mat-raised-button>
			{{ T.CLEAR_ACTIVIATION_DATE_BUTTON | translate }}
		</button>

		<button (click)="ok()" [disabled]="startFormControl.invalid || endFormControl.invalid" color="accent" mat-raised-button>
			{{ T.USER_DIALOG_SET_ACTIVIATION_DATE_BUTTON | translate }}
		</button>
	</ng-container>
</sim-basic-material-dialog>
